import React from 'react';
import { Switch } from 'react-router-dom';
import { __RouterContext as RouterContext } from 'react-router';
import invariant from 'invariant';
import matchPath from '@src/components/route/route-switch-enhance/match-path';
import routeConfigJson from '@src/pages/app-router/route-config.json';

const getFlmRenderPagePath = () => {
  const renderPage = document.querySelector('meta[name="flm:render_page"]')?.content;
  if (!renderPage) {
    return;
  }
  const metaRenderPath = routeConfigJson.routes.find(item => item.name === renderPage);
  return metaRenderPath?.path;
};

export default class RouteSwitchEnhance extends Switch {
  render() {
    return (
      <RouterContext.Consumer>
        {context => {
          invariant(context, 'You should not use <Switch> outside a <Router>');
          const metaRenderPath = getFlmRenderPagePath();

          if (metaRenderPath) {
            if (this.props.location) {
              this.props.location.pathname = metaRenderPath;
            }
            if (context.location) {
              context.location.pathname = metaRenderPath;
            }
          }
          const location = this.props.location || context.location;
          let element, match;
          React.Children.forEach(
            this.props.children,
            child => {
              if (match == null && React.isValidElement(child)) {
                element = child;
                const path = child.props.path || child.props.from;
                match = path ? matchPath({ pathname: location.pathname, query: location.search }, { ...child.props, path }) : context.match;
              }
            },
            undefined
          );
          return match ? React.cloneElement(element, { location, computedMatch: match }) : null;
        }}
      </RouterContext.Consumer>
    );
  }
}

Object.assign(RouteSwitchEnhance, Switch);
